import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  details: {
    padding: pxToRem(24),
  },
  keywords: {
    paddingTop: '1rem',
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingTop: 0,
      },
    },
  },
  infoBlock: {
    lineHeight: pxToRem(16),
    padding: 'pxToRem(16) pxToRem(0) pxToRem(0) pxToRem(0)',
    margin: 'pxToRem(16) pxToRem(0) pxToRem(0) pxToRem(0)',
  },
  noDimensionDetail: {
    marginBottom: pxToRem(40),
  },
  noDimensionDetailItems: {
    marginBottom: pxToRem(40),
    marginLeft: pxToRem(24),
    marginRight: pxToRem(24),
    width: '1',
  },
  contractActivity: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  activityContent: {
    background: 'transparent',
    boxShadow: 'none',
  },
  showMore: {
    float: 'right',
  },
  activityShowing: {
    fontWeight: 400,
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    selectors: {
      '& span': {
        fontWeight: 600,
      },
    },
  },
  associatedContracts: {
    fontWeight: 400,
    fontSize: pxToRem(14),
    color: theme.palette.neutralSecondary,
  },
  showMoreActivityButton: {
    float: 'right',
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
    },
  },
  showMoreActivity: {
    fontSize: pxToRem(14),
    cursor: 'pointer',
    marginTop: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  scrollablePane: {
    minHeight: pxToRem(100),
    maxHeight: pxToRem(450),
    overflowY: 'auto',
    [layout.breakpoints.min.xl]: {
      width: 'fit-content',
    },
  },
  description: {
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
  },
});
